/* IKAI — slider.js (null-safe, Sep 2026)
   .pm-slider-wrapper ke andar ".pmSlider" class wala track ho tabhi chalega.
   Pehle track na milne pe "slider.children of null" TypeError aata tha
   (home-trending mein track ki class "pm-slider" hai, id "pmSlider" — usko main.js handle karta hai).
   Ab defer se load hota hai (render-blocking nahi). */
(function () {
  'use strict';
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function init(wrapper) {
    if (wrapper.dataset.pmWrapReady === '1') return;
    var slider = wrapper.querySelector('.pmSlider');
    if (!slider || !slider.children.length || slider.dataset.pmReady === '1') return;
    wrapper.dataset.pmWrapReady = '1';
    slider.dataset.pmReady = '1';

    var nextBtn = wrapper.querySelector('.pm-next');
    var prevBtn = wrapper.querySelector('.pm-prev');

    Array.prototype.slice.call(slider.children).forEach(function (s) {
      var c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a, button, input, [tabindex]').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      c.querySelectorAll('img').forEach(function (img) { img.setAttribute('loading', 'lazy'); });
      slider.appendChild(c);
    });

    var half = slider.children.length / 2, index = 0, w = 0, timer = null, visible = true, hovered = false;
    function measure() { w = slider.children[0].offsetWidth + 25; }
    function apply(a) { slider.style.transition = a ? 'transform 0.4s ease' : 'none'; slider.style.transform = 'translateX(-' + index * w + 'px)'; }
    function resetLoop() { if (index >= half) { index = 0; apply(false); } }
    function next() { if (!w) measure(); index++; apply(true); slider.addEventListener('transitionend', resetLoop, { once: true }); }
    function prev() { if (!w) measure(); index--; if (index < 0) index = half - 1; apply(true); }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    function sync() {
      var ok = !reduceMotion && visible && !hovered && !document.hidden;
      if (ok && !timer) timer = setInterval(next, 3000);
      if (!ok && timer) { clearInterval(timer); timer = null; }
    }
    wrapper.addEventListener('mouseenter', function () { hovered = true; sync(); });
    wrapper.addEventListener('mouseleave', function () { hovered = false; sync(); });
    document.addEventListener('visibilitychange', sync);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; sync(); }, { threshold: 0.1 }).observe(wrapper);
    } else { sync(); }

    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { measure(); apply(false); }, 150); }, { passive: true });
    requestAnimationFrame(measure);
  }

  function boot() { document.querySelectorAll('.pm-slider-wrapper').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
